import React, { useState, useEffect } from "react";
import "../../style/Liste.css";
import { Link } from "react-router-dom";
import axios from "axios";
import { alphaList } from "../../utils/functions";
import { Helmet } from "react-helmet";

const API_URL = process.env.REACT_APP_API_URL;

function ListeFournisseursMontures() {
  const [fournisseurs, setFournisseurs] = useState([]);

  useEffect(() => {
    function getFournisseurs() {
      axios
        .get(`${API_URL}/api/fournisseurs`)
        .then((res) => res.data)
        .then((data) => {
          setFournisseurs(alphaList(data));
        });
    }

    getFournisseurs();
  }, []);

  return (
    <div className="listeMain">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Liste des fabricants de montures</title>
      </Helmet>
      <h1>Liste des fournisseurs</h1>
      <ul className="listContainer">
        {fournisseurs
          ? Object.keys(fournisseurs).map((key) => (
              <div className="oneLetterContainer">
                <h2>{key}</h2>
                {fournisseurs[key].map((fournisseur) => (
                  <li key={fournisseur.id}>
                    <Link to={`/fournisseurs-montures/${fournisseur.id}`}>
                      {fournisseur.nom}
                    </Link>
                  </li>
                ))}
              </div>
            ))
          : null}
      </ul>
    </div>
  );
}

export default ListeFournisseursMontures;
